import React from "react";
import { Modal } from "react-bootstrap";
import authenticationService from "../_services/authentication.service";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import accessoriesManagementService from "../_services/accessoriesManagement.service";
import accessoryfinderService from "../_services/accessoryfinder.service";

class UpdateModeAccessoriesManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandData: props.brandData,
      isImagePreview: true,
      editorState: EditorState.createEmpty(),
      imagePreviewUrl: "",
      model: props.updateModel,
      errors: {},
      isFormValid: false,
      message: "",
      isUpdated: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.ddlRowChnage = this.ddlRowChnage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  ddlRowChnage = (idx) => (e) => {
    const { name, value } = e.target;
    let rows = [...this.state.model.accessoryModelMapping];
    rows[idx][name] = value;
    if (value !== "") {
      rows[idx]["error"] = { ...rows[idx]["error"], [name]: "" };
      if (name === "brandName") {
        accessoryfinderService
          .getVacuumModelsByBrand(value)
          .then((data) => {
            if (data.isSuccess) {
              rows[idx]["vacuumModel"] = data.data;
              this.setState({
                model: { ...this.state.model, accessoryModelMapping: rows },
              });
            }
          })
          .catch((error) => console.log("Error :" + error));
      } else if (name === "vacuumModelId") {
        accessoryfinderService
          .getModelSeries(value)
          .then((data) => {
            if (data.isSuccess) {
              rows[idx]["vacuumSeries"] = data.data;
              this.setState({
                model: { ...this.state.model, accessoryModelMapping: rows },
              });
            }
          })
          .catch((error) => console.log("Error :" + error));
      } else {
        this.setState({
          model: { ...this.state.model, accessoryModelMapping: rows },
        });
      }
    }
  };
  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.state.model.accessoryModelMapping];
    rows.splice(idx, 1);
    this.setState({
      model: { ...this.state.model, accessoryModelMapping: rows },
    });
  };

  handleSubmit = (e) => {
    if (this.validateForm()) {
      let { model } = this.state;
      let formData = new FormData();
      formData.append("AccessoryId", model.accessoryId);
      formData.append("Accessory_modelNo", model.accessory_modelNo);
      formData.append("AccessoryName", model.accessoryName);
      formData.append("Image", model.image);
      formData.append("ImagePath", model.imagePath);
      formData.append("Description", model.description);
      formData.append("Enabled", model.enabled);
      formData.append("CreatedBy", model.createdBy);
      formData.append(
        "accessoryModelMappingJsonString",
        JSON.stringify(model.accessoryModelMapping),
      );

      accessoriesManagementService
        .update(formData)
        .then((data) =>
          this.setState({ isUpdated: data.isSuccess, message: data.message }),
        )
        .catch((error) => console.log("Error :" + error));
    }
  };

  validateForm() {
    let { model } = this.state;
    let rows = [...this.state.model.accessoryModelMapping];

    let errors = {};
    let isFormValid = true;

    if (!model.accessory_modelNo) {
      isFormValid = false;
      errors["accessory_modelNo"] = "Enter Accessory ModelNo";
    }
    if (!model.accessoryName) {
      isFormValid = false;
      errors["accessoryName"] = "Enter Accessory Name";
    }
    // if (!model.image) {
    // isFormValid = false;
    // errors["image"] = "Select Image";
    // }

    let desc = model.description.replace(/<[^>]*>/g, "").trim();

    if (desc === null || desc === "") {
      isFormValid = false;
      errors["description"] = "Enter Description";
    }

    rows.map((item, idx) => {
      if (!item.brandName) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          brandName: "Select Brand Name",
        };
        isFormValid = false;
      }
      if (!item.vacuumModelId) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          vacuumModelId: "Select Vacuum Model",
        };
        isFormValid = false;
      }
      if (item.vacuumSeries.length > 0 && !item.vacuumSeriesId) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          vacuumSeriesId: "Select vacuum SeriesId",
        };
        isFormValid = false;
      }
      return isFormValid;
    });
    this.setState({
      model: { ...this.state.model, accessoryModelMapping: rows },
      errors: errors,
    });
    return isFormValid;
  }
  handleAddRow = () => {
    let { model } = this.state;
    const item = {
      id: 0,
      brandName: "",
      accessoryId: model.accessoryId,
      vacuumModelId: "",
      vacuumModel: [],
      vacuumSeriesId: "",
      vacuumSeries: [],
      enabled: true,
      createdBy: authenticationService.currentUserValue.id,
      error: {},
    };
    let accessoryModelMapping = this.state.model.accessoryModelMapping;
    accessoryModelMapping.push(item);
    this.setState({
      model: {
        ...this.state.model,
        accessoryModelMapping: accessoryModelMapping,
      },
    });
  };

  handleChange(event) {
    const { name, value } = event.target;
    const { model, errors } = this.state;

    this.setState({
      model: {
        ...model,
        [name]: value,
      },
      errors: {
        ...errors,
        [name]: "",
      },
    });
  }
  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
    let { model, errors } = this.state;
    model.description = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
    );

    this.setState({
      model: { ...model, model },
      errors: {
        ...errors,
        description: "",
      },
    });
  };

  handleImagePreview = (e) => {
    this.setState({ isImagePreview: !this.state.isImagePreview });
  };
  getDescription() {
    let { model } = this.state;
    if (model.description !== null && model.description !== "") {
      const blocksFromHtml = htmlToDraft(model.description);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap,
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState: editorState });
    }
  }
  componentDidMount() {
    this.getDescription();
  }
  handleImageChange(e) {
    e.preventDefault();
    let file = e.target.files[0];
    let fileName = file.name;
    let size = file.size;
    let fileExtn = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
    let reader = new FileReader();

    if (this.validateFile(fileExtn, size)) {
      let { model } = this.state;
      model.image = file;

      reader.onloadend = () => {
        this.setState({
          model: { ...model, model },
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);
    } else {
      e.target.value = null;
    }
  }
  validateFile(fileExtn, size) {
    let { errors } = this.state;
    let isValid = true;
    let message = "";
    const extnList = ["JPEG", "jpg", "PNG", "png"];
    const list = extnList.filter((u) => u === fileExtn);
    if (list && list.length === 0) {
      isValid = false;
      message = "Only JPEG, PNG files are allowed";
    } else if (size > 2000000) {
      message = "File size should not be more than 2MB";
      isValid = false;
    }
    this.setState({
      errors: {
        ...errors,
        image: message,
      },
    });
    return isValid;
  }
  render() {
    let {
      model,
      message,
      isUpdated,
      editorState,
      isImagePreview,
      imagePreviewUrl,
      brandData,
    } = this.state;
    const { updateClose } = this.props;
    let imagePreview = null;

    if (imagePreviewUrl !== "") {
      isImagePreview = true;
    }
    if (imagePreviewUrl) {
      imagePreview = (
        <img className="imgPreview" src={imagePreviewUrl} alt="" />
      );
    } else {
      imagePreview = "";
    }
    let btnText = "Hide Preview";
    if (isImagePreview) {
      btnText = "Show Preview";
    }
    return (
      <React.Fragment>
        <Modal
          show="true"
          size="lg"
          aria-labelledby="example-modal-sizes-title-lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>Update Accessories Management</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-sm-12">
                <div className="box box-primary">
                  <form name="form">
                    <div className="box-body">
                      <div className="row">
                        <div className="col-sm-12">
                          {message && (
                            <div class="alert alert-success" role="alert">
                              {message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="accessory_modelNo">
                              Accessory Model No
                            </label>
                            <input
                              id="accessory_modelNo"
                              name="accessory_modelNo"
                              value={model.accessory_modelNo}
                              onChange={this.handleChange}
                              maxLength="100"
                              type="text"
                              className={
                                "form-control" +
                                (this.state.errors.accessory_modelNo
                                  ? " invalid"
                                  : "")
                              }
                              placeholder="Accessory Model No"
                            />
                            {this.state.errors.accessory_modelNo && (
                              <small class="help-block">
                                {this.state.errors.accessory_modelNo}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="accessoryName">
                              Accessory Name{" "}
                            </label>
                            <input
                              id="accessoryName"
                              name="accessoryName"
                              value={model.accessoryName}
                              onChange={this.handleChange}
                              maxLength="100"
                              type="text"
                              className={
                                "form-control" +
                                (this.state.errors.accessoryName
                                  ? " invalid"
                                  : "")
                              }
                              placeholder="Accessory Name"
                            />
                            {this.state.errors.accessoryName && (
                              <small class="help-block">
                                {this.state.errors.accessoryName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="description ">Description</label>
                            <div
                              style={{ minHeight: "300px" }}
                              class={
                                this.state.errors.description
                                  ? " invalid"
                                  : "border"
                              }
                            >
                              <Editor
                                editorState={editorState}
                                editorStyle={{ lineHeight: "75%" }}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                toolbar={{
                                  inline: {
                                    visible: true,
                                    inDropdown: false,
                                    bold: { visible: true },
                                    italic: { visible: true },
                                    underline: { visible: true },
                                    strikeThrough: { visible: true },
                                    monospace: { visible: true },
                                  },
                                  blockType: { visible: true },
                                  fontSize: { visible: true },
                                  fontFamily: { visible: true },
                                  list: {
                                    visible: true,
                                    inDropdown: true,
                                    unordered: { visible: true },
                                    ordered: { visible: true },
                                    indent: { visible: true },
                                    outdent: { visible: true },
                                  },
                                  textAlign: {
                                    visible: true,
                                    inDropdown: true,
                                    left: { visible: true },
                                    center: { visible: true },
                                    right: { visible: true },
                                    justify: { visible: true },
                                  },
                                  colorPicker: { visible: true },
                                  textIndent: {
                                    inDropdown: false,
                                    className: undefined,
                                    component: undefined,
                                    dropdownClassName: undefined,
                                    options: ["indent", "outdent"],
                                    indent: { className: undefined },
                                    outdent: { className: undefined },
                                  },
                                  link: {
                                    visible: false,
                                    inDropdown: true,
                                    addLink: { visible: true },
                                    removeLink: { visible: true },
                                  },
                                  image: {
                                    visible: false,
                                    fileUpload: true,
                                    url: true,
                                  },
                                  history: {
                                    visible: true,
                                    inDropdown: true,
                                    undo: { visible: true },
                                    redo: { visible: true },
                                  },
                                }}
                                onEditorStateChange={this.onEditorStateChange}
                              />
                            </div>
                            {this.state.errors.description && (
                              <small class="help-block">
                                {this.state.errors.description}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="AccessoryImage">
                              Accessory Image
                            </label>
                            <input
                              type="file"
                              onChange={(e) => this.handleImageChange(e)}
                              accept=".jpg,.jpeg,.png"
                              id="AccessoryImage"
                              ref={(ref) => (this.fileInput = ref)}
                              name="image"
                              className={
                                "form-control" +
                                (this.state.errors.image ? " invalid" : "")
                              }
                              placeholder="Accessory Image"
                            />
                            {this.state.errors.image && (
                              <small class="help-block">
                                {this.state.errors.image}
                              </small>
                            )}
                            {!isImagePreview ? <div>{imagePreview}</div> : null}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            {false ? (
                              <button
                                className="submitButton"
                                type="button"
                                onClick={(e) => this.handleImagePreview(e)}
                              >
                                {btnText}
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label htmlFor="tbl_vacuumModelSeries">
                              Model Details
                            </label>
                            <table
                              className="table table-bordered"
                              id="tbl_vacuumModelSeries"
                            >
                              <tbody>
                                {model.accessoryModelMapping &&
                                  model.accessoryModelMapping.map(
                                    (item, idx) => (
                                      <tr id="addr0" key={idx}>
                                        <td style={{ width: "8%" }}>
                                          {idx + 1}{" "}
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.brandName}
                                            onChange={this.ddlRowChnage(idx)}
                                            // className={'form-control' +(item.error.brandName  ? ' invalid' : '')}
                                            className="form-control"
                                            name="brandName"
                                          >
                                            <option
                                              key="brandSelected"
                                              value=""
                                            >
                                              Select Brand
                                            </option>

                                            {brandData.length &&
                                              brandData.map((itemInner) => (
                                                <option
                                                  key={itemInner.value}
                                                  value={itemInner.value}
                                                >
                                                  {itemInner.text}
                                                </option>
                                              ))}
                                          </select>
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.vacuumModelId}
                                            onChange={this.ddlRowChnage(idx)}
                                            //  className={'form-control' +(item.error.vacuumModelId  ? ' invalid' : '')}
                                            className="form-control"
                                            name="vacuumModelId"
                                          >
                                            <option
                                              key="modelSeriesSelected"
                                              value=""
                                            >
                                              Select Vacuum Model
                                            </option>
                                            {item.vacuumModel &&
                                              item.vacuumModel.map(
                                                (itemInner) => (
                                                  <option
                                                    key={itemInner.value}
                                                    value={itemInner.value}
                                                  >
                                                    {itemInner.text}
                                                  </option>
                                                ),
                                              )}
                                          </select>
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.vacuumSeriesId}
                                            onChange={this.ddlRowChnage(idx)}
                                            // className={'form-control' +(item.error.vacuumSeriesId  ? ' invalid' : '')}
                                            className="form-control"
                                            name="vacuumSeriesId"
                                          >
                                            <option
                                              key="modelSeriesSelected"
                                              value=""
                                            >
                                              Select Vacuum Model Series
                                            </option>
                                            {item.vacuumSeries &&
                                              item.vacuumSeries.map(
                                                (itemInner) => (
                                                  <option
                                                    key={itemInner.value}
                                                    value={itemInner.value}
                                                  >
                                                    {itemInner.text}
                                                  </option>
                                                ),
                                              )}
                                          </select>
                                        </td>
                                        <td style={{ width: "11%" }}>
                                          {idx > 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger btn-sm"
                                              onClick={this.handleRemoveSpecificRow(
                                                idx,
                                              )}
                                            >
                                              Remove
                                            </button>
                                          ) : null}
                                        </td>
                                      </tr>
                                    ),
                                  )}
                              </tbody>
                            </table>
                            <button
                              type="button"
                              onClick={this.handleAddRow}
                              className="btn btn-outline-primary btn-sm"
                            >
                              Add Row
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <hr />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 text-center">
                          <button
                            type="button"
                            onClick={this.handleSubmit}
                            className="btn btn-primary btn-sm ml-2 ts-buttom btn btn-primary"
                          >
                            UPDATE
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            onClick={() => updateClose(isUpdated)}
                            className="btn btn-danger btn-sm ml-2 ts-buttom btn btn-primary"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
export default UpdateModeAccessoriesManagement;
